import React from 'react';

import Loader from '@mindtickle/loader';

import { useMomentLocale } from './useMomentLocale';

function MomentLocaleProvider({
  children,
  loader = <Loader type="Full" />,
  locale,
  isAdmin,
}: {
  children: React.ReactNode;
  loader?: React.ReactElement;
  locale?: string;
  isAdmin?: boolean;
}) {
  const { loading } = useMomentLocale(locale, isAdmin);
  return <>{loading ? loader : children}</>;
}

export default MomentLocaleProvider;
